import React, { Component } from 'react';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import axios from 'axios';

import { SHIP_QTY_CHANGE_URL } from '../../../actions/url'; 

class ShipQtyModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      quantity: null,
    }
  }
  componentWillMount() {
  }

  handleSaveButtonClick = () => {
    const { quantity } = this.state;
    axios.put(
      `${SHIP_QTY_CHANGE_URL}${this.props.id}`,
      { quantity: Number(quantity) },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
    .then((response) => {
      alert(response.data);
      this.props.successSaved();
    }, (err) => {
      alert(err.data);
    });
  }

  handleChange = event => {
    this.setState({quantity: event.target.value});
  }
  
  renderSaveButton() {
    return (
      <div
        style={{
          width: '100%',
          marginTop: '5px',
          alighItems: 'center',
          textAlign: 'center',
        }}
      >
        <Button
          bsStyle="success"
          onClick={this.handleSaveButtonClick}
        >
          <Translate value="save" />
        </Button>
      </div>
    );
  }

  render() {
    return (
      <div>
        <Input
          value={this.state.quantity} 
          name="quantity"
          type="number"
          onChange={this.handleChange}
        />
        { this.renderSaveButton() }
      </div>
    );
  }
}

export default ShipQtyModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/components/ShipQtyModal.jsx